import {ComponentChild, h} from 'preact'
import Panel from '../panel'

const CommunityHeader = ({ switcher }: {switcher: ComponentChild}) => {
  return (
    <Panel
      customClass='homepage-widget'
      title={
        <div className='panel-title-with-switch'>
          Header
          { switcher }
        </div>
      }
    />
  )
}

export default CommunityHeader
